module.exports = __webpack_public_path__ + "img/exit-popup.8d7bb59.jpg";